// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gyPC","placeholdersHeader":"styles_placeholdersHeader__xqTbk","editorStyle":"styles_editorStyle__1G4u0","placeholdersBox":"styles_placeholdersBox__3MVn-"};